/** Teams UI labels — DB role `installation_team` is shown as Installation member. */
/*developer: Nithin
    date : 2024-06-19
    changes : Replaced Telecaller With Staff */

export const ROLE_LABELS = {
  designer: 'Designer',
  installation_team: 'Installation Team',
  accountant: 'Accountant',
  store_incharge: 'Store Incharge',
  owner: 'Owner',
  admin: 'Admin',
  client_coordinator: 'Client Coordinator',
  sales_executive: 'Sales Executive',
  field_marketing: 'Field Marketing',
  social_media: 'Social Media',
  carpenter: 'Carpenter',
  electrician: 'Electrician',
  painter: 'Painter',
  plumber: 'Plumber'
};

export const formatTeamRoleLabel = (role) => ROLE_LABELS[role] || role?.replace(/_/g, ' ') || '—';

export const INSTALLATION_TRADES = [
  { value: 'carpenter', label: 'Carpenter' },
  { value: 'electrician', label: 'Electrician' },
  { value: 'painter', label: 'Painter' },
  { value: 'plumber', label: 'Plumber' }
];

export const formatInstallationTrade = (trade) => {
  if (!trade) return '—';
  const found = INSTALLATION_TRADES.find((t) => String(t.value).toLowerCase() === String(trade).toLowerCase());
  if (found) return found.label;
  return String(trade).charAt(0).toUpperCase() + String(trade).slice(1).toLowerCase();
};

export const getRoleBadgeStyle = (role) => {
  const normalized = String(role || '').toLowerCase();
  switch (normalized) {
    case 'owner':
      return 'bg-amber-50 text-amber-700 border-amber-200/50';
    case 'admin':
      return 'bg-rose-50 text-rose-700 border-rose-200/50';
    case 'designer':
      return 'bg-indigo-50 text-indigo-700 border-indigo-200/50';
    case 'accountant':
      return 'bg-orange-50 text-orange-700 border-orange-200/50';
    case 'designer':
      return 'bg-pink-50 text-pink-700 border-pink-200/50';
    case 'sales_executive':
    case 'field_marketing':
      return 'bg-blue-50 text-blue-700 border-blue-200/50';
    case 'client_coordinator':
    case 'client_coordinator':
      return 'bg-sky-50 text-sky-700 border-sky-200/50';
    case 'social_media':
      return 'bg-cyan-50 text-cyan-700 border-cyan-200/50';
    case 'installation_team':
    case 'field-officer':
      return 'bg-teal-50 text-teal-700 border-teal-200/50';
    case 'store_incharge':
      return 'bg-cyan-50 text-cyan-700 border-cyan-200/50';
    default:
      return 'bg-slate-50 text-slate-700 border-slate-200/50';
  }
};
